const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL ? process.env.PUBLIC_URL + pathname : pathname;

export default  toAbsoluteUrl;